<template>
  <div class="welcome">
    <div class="bg"></div>
    <div class="top">
      <div class="content">
        <div class="header1">
          <span><i class="el-icon-user-solid"></i>info@iDentsmile.com</span>
          <span><i class="el-icon-phone-outline"></i>Call iDentSmile</span>
          <span><i class="el-icon-collection-tag"></i>Membership Quote</span>
          <a>Sign In</a>
          <span class="select">
            <i class=""></i>
            EN-US
            <i class="el-icon-arrow-down"></i>
          </span>
        </div>
        <div class="header2">
          <div class="headerTitle">
            <a>Product</a>
            <a>Pricing</a>
            <a>Company</a>
            <a>Contact</a>
          </div>
          <div class="btn">FREE TRIAL</div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="content">
        <div class="menu">
          <span>ABOUT</span>
          <span>THE TEAM</span>
          <span>MEDIA</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'Welcome',
    components: {
    },
    data() {
      return {

      }
    },
    computed: {

    },
    created() {

    },
    methods: {

    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  .bg{position: fixed;top:0;left:0;z-index: -1;width:100vw;height:calc(100vh - 80px);display: flex;background-image: url(../assets/imgs/home_bg.png);background-size: auto 100%;background-position: center;}
  .welcome{width: 100vw;height: 100vh;display: flex;flex-direction: column;}
  .top{height:calc(100vh - 80px);background:linear-gradient(rgba(3, 72, 68, 0.75),rgba(7, 174, 164, 0.225));}
  .bottom{flex-shrink: 0;background-color: #F9F3EE;}
  .content{width: 1200px;margin:auto;}
  .content .menu{color: rgba(0, 0, 0, 0.3);display: flex;justify-content: space-around;align-items: center;height: 80px;font-weight: bold;}
  .header1{border-bottom: 2px solid #2B6561;color: #F9F3EE;height: 80px;display: flex;align-items: center;justify-content: flex-end;}
  .header1 i{margin:0 10px;font-size: 14px;}
  .header1 a{color: #F9F3EE;margin:0 30px;cursor: pointer;}
  .header1 span{margin:0 20px;display: flex;align-items: center;}
  .header1 .select i{margin:0 5px;}
  .header2{border-bottom: 2px solid #2B6561;color: #F9F3EE;height: 80px;display: flex;align-items: center;justify-content: flex-end;}
  .header2 .headerTitle{padding-left: 100px;width: 100%;display: flex;align-items: center;justify-content: center;}
  .header2 a{color:#F9F3EE;margin:0 30px;font-weight: bold;}
  .header2 .btn{flex-shrink: 0;width: 120px;height: 40px;display: flex;align-items: center;justify-content: center;border-radius: 20px;background-color: #ffffff;color: #034844;font-weight: bold;}
  @media (max-width: 768px) {
    .form{width:80vw;padding:20px 20px 40px 20px;border-radius: 10px;}
    .form h1{font-size:26px;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {
  }
</style>
